module.exports = __webpack_public_path__ + "img/stephen-pfp.d749a570.jpeg";